<template>
  <div class="list-wrap">
    <template v-if="code !=='abroadData'">
      <div class="list-item"
         v-for="item in contentList"
         :key="item.id">
      <div class="item-left"
           v-if="item.systemFile">
        <IconWrap :width="283"
                  :height="164"
                  :url="picUrl(item.systemFile)">
        </IconWrap>
      </div>
      <div class="item-right">
        <div class="title"
             @click="toDetails(item)">
          {{ item.title }}
        </div>
        <div class="content"
          v-html="item.summary"></div>
      </div>
    </div>
    </template>
    <template v-else>
      <StaticTable></StaticTable>
    </template>
  </div>
</template>

<script>
import commonDetail from '@/views/MIndex/mixin/index'
import StaticTable from './staticTable.vue'
export default {
  props: {
    contentList: Array,
    tag: String,
    code: String,
    selectedId: Number
  },
  components: {StaticTable},
  mixins: [commonDetail],
  data() {
    return {
      data: [],
      total: 0,
      isShowMore: true
    }
  },
  watch: {
    code(val) {
      if (val) {
        if (
          val === 'abroadData' ||
          val === 'huaKnowledgeData' ||
          val === 'xwshsxx'
        ) {
          this.isShowMore = false
        } else {
          this.isShowMore = true
        }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    toMore() {
      window.open('https://scnu.ipsunlight.com/fvue/home')
    },
    picUrl(val) {
      const baseUrl = process.env.VUE_APP_BASE_IMGURL
      return baseUrl + val.filePath
    }
  }
}
</script>

<style lang="scss" scoped>
.more {
  cursor: pointer;
}
</style>
